export default __webpack_public_path__ + "static/media/press_room_thumb3.efd354a0.png";